import store from '@/store'
export default [
  {
    path: '/notification-schedules',
    name: 'notification-schedule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-schedule/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('notificationSchedule/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/notification-schedules/:id',
    name: 'notification-schedule-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-schedule/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('notificationSchedule/dataBeforeCreate')
      await store.dispatch('notificationSchedule/find', to.params.id)
      next()
    }
  }
]
